import { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { IonGrid, IonRow, IonCol, IonHeader, IonToolbar, IonIcon, IonImg, IonFab, IonFabButton, IonFabList } from '@ionic/react';
import { home, call, ellipsisVertical } from 'ionicons/icons';
import { Constants } from '../defines/Constants';
import axios from 'axios';
import './Header.css';

interface Props {
    logo: string,
    phone: string
}
const Header = (props: Props) => {
    const history = useHistory();
    const location = useLocation();
    const currentPage = location.pathname;
    var showBack = false;
    if (currentPage === '/home' || currentPage === '/contact' || currentPage === '/profile') {
        showBack = false;
    } else {
        showBack = true;
    }
    const goBack = () => {
        history.replace('/home');
    }
    const [socials, setSocials] = useState([]) as any;
    const socialsApi = Constants.api.socials;
    useEffect(() => {
        const getSocials = async () => {
            try {
                const results = await axios.get(socialsApi);
                if (results.status === 200) {
                    setSocials(results.data.social_items);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getSocials();
    }, [socialsApi]);
    const socialsEl = socials.map((item: any, index: number) =>
        <a href={item.link} key={"index" + index} target="_blank" rel="noreferrer">
            <IonFabButton>
                <IonImg src={Constants.uploads + 'socials/' + item.icon_svg} />
            </IonFabButton>
        </a>
    )
    return (
        <IonHeader>
            {showBack ? (
                <span className="header-back-btn">
                    <IonIcon icon={home} onClick={goBack} />
                </span>
            ) : (
                <IonFab vertical="top" horizontal="end" className="header-socials">
                    <IonFabButton>
                        <IonIcon icon={ellipsisVertical} />
                    </IonFabButton>
                    <IonFabList side="bottom">
                        {socialsEl}
                    </IonFabList>
                </IonFab>
            )}
            <IonToolbar className="header-toolbar ion-no-padding">
                <div className="header-container bg-blue">
                    <IonGrid>
                        <IonRow>
                            <IonCol size="12">
                                <div className="header-content">
                                    {props.phone !== null &&
                                        <div className="header-call">
                                            <a href={"tel:" + props.phone}>
                                                <span className="header-phone-number">
                                                    {props.phone}
                                                </span>
                                                <span className="header-icon">
                                                    <IonIcon icon={call} />
                                                </span>
                                            </a>
                                        </div>
                                    }
                                </div>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </div>
            </IonToolbar>
            {props.logo !== null &&
                <div className="header-logo-box">
                    <IonImg src={Constants.uploads + 'config/' + props.logo} className="header-logo" />
                </div>
            }
        </IonHeader>
    )
}
export default Header;